import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import './custom.d.ts';
import './FontAwesome';
import {App} from './App';
import './polyfill';
import {config} from './config';

import {setConfig} from './config';
import './i18next-init';

setConfig(config);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
